module.exports = __webpack_public_path__ + "img/979adec.webp";